export type IRedirectToPage = (url: string, delay?: number) => void;

export function redirectToPage(url: string, delay = 0): void {
  setTimeout(() => {
    window.location.href = url;
  }, delay);
}
